"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerSim = void 0;
var trainer_sim_1 = require("./trainer-sim");
Object.defineProperty(exports, "TrainerSim", { enumerable: true, get: function () { return trainer_sim_1.TrainerSim; } });
